/**
 * Dispatched on window whenever the website signs out (authStore.clearAuth).
 * services/api.ts hears it and asks the server to drop the sign-in pass cookie,
 * which page scripts cannot reach themselves. A module of its own so that tests
 * which replace the auth store still get it.
 */
export const SIGNED_OUT_EVENT = 'channelplex:signed-out';
